export default __webpack_public_path__ + "images/assets/47bc38732c8de23c69c349ed2d1b1e4d.svg";